import React, { useEffect, useState } from "react";
import { EditBlockOption } from "../EditBlock";
import {
    OptionIsRight,
    OptionType,
    TopicType
} from "../../../../../service/homework";
import { EditDuoxuanPure } from "../../../../exam/addExam/components/EditDuoxuan";
import { QuestionType } from "../../../../../service/service";
import { EditBlock } from "../EditBlock";

interface EditDuoxuanProps {
    topic: TopicType;
    blockOption?: EditBlockOption;
    onChangeNow?: (topic: TopicType) => void;
    onChange: (topic: TopicType) => void;
}

export default function EditDuoxuan({
    topic,
    blockOption,
    onChange,
    onChangeNow
}: EditDuoxuanProps) {
    const [innerTopic, setInnerTopic] = useState(topic);

    useEffect(() => {
        onChangeNow && onChangeNow(innerTopic);
    }, [innerTopic]);

    const onInputChange = (index: number, value: string) => {
        const answers = [...innerTopic.answers];
        answers[index].content = value;
        setInnerTopic({ ...innerTopic, answers });
    };

    const onCheckChange = (index: number, isChecked: boolean) => {
        const answers = [...innerTopic.answers];
        answers[index].isRight = isChecked
            ? OptionIsRight.Right
            : OptionIsRight.Wrong;
        setInnerTopic({ ...innerTopic, answers });
    };

    const isChecked = (option: OptionType) => {
        return option.isRight === OptionIsRight.Right;
    };

    const onEditBlockChange = (topic: TopicType) => {
        const newTopic = { ...innerTopic };
        setInnerTopic({ ...newTopic, trunk: topic.trunk, score: topic.score });
        onChange && onChange(topic);
    };

    const deleteItem = (index: number) => {
        const newTopic = { ...innerTopic };
        newTopic.answers.splice(index, 1);
        setInnerTopic(newTopic);
    };

    const addItem = () => {
        const newTopic = { ...innerTopic };
        newTopic.answers.push({ content: "", isRight: OptionIsRight.Wrong });
        setInnerTopic(newTopic);
    };

    return (
        <EditBlock
            {...blockOption}
            type={QuestionType.DuoXuan}
            topic={innerTopic}
            onChange={onEditBlockChange}>
            <EditDuoxuanPure
                innerTopic={innerTopic}
                isChecked={isChecked}
                onCheckChange={onCheckChange}
                onInputChange={onInputChange}
                deleteItem={deleteItem}
                addItem={addItem}
            />
        </EditBlock>
    );
}
